<template>

    <m-edit1/>

    <m-div v-bind='{...{},...{}}' :style='"padding: 64px 0px;\n"' class="container-fluid  background-gradiant" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="container-custom" >
                <template #default>   <m-h2 v-bind='{...{},...{}}' :style='"font-size: clamp(22px, 2vw, 34px);"' class="text-center font-weight-bold  mb-4 text-dark" >
                <template #default>فروشگاه اکسسوری و لوازم جانبی موبایل   </template>
                </m-h2><m-h4 v-bind='{...{},...{}}' :style='"font-size: 19px;\n"' class="text-center mb-4 text-caption" >
                <template #default>بهترین محصولات با تضمین اصالت و گارانتی بازگشت وجه 7 روزه   </template>
                </m-h4><m-div v-bind='{...{},...{}}' :style='"margin-top: 16px;"' class="text-center" >
                <template #default>   <m-a v-bind='{...{"href":"https:\/\/medicalmobile.ir\/products?category=23","target":"_self"},...{}}' :style='""' class="btn btn-primary mb-2" >
                <template #default>محصولات پر فروش   <m-icon v-bind='{...{"icon":""},...{}}' :style='""' class="bi bi-arrow-left-circle-fill mx-1" ></m-icon></template>
                </m-a><m-a v-bind='{...{"href":"https:\/\/medicalmobile.ir\/contact-us","target":"_self"},...{}}' :style='""' class="btn btn-outline-primary mb-2 mr-2" >
                <template #default>مشاوره و خرید   <m-icon v-bind='{...{"icon":""},...{}}' :style='""' class="bi bi-arrow-left-circle-fill mx-1" ></m-icon></template>
                </m-a></template>
                </m-div></template>
                </m-div></template>
                </m-div><m-products-3 v-bind='{...{"perPage":12,"productCardName":"mProductCard516","cardCLass":"my-1","cardWrapperCLass":"col-lg-4 archive-parent-item","showCategoriesSlider":false,"singlePrice":false,"offerType":"number","offerStatus":true,"productBrandProp":false,"productSearchProp":true,"productQuantityProp":true,"productFeatureProp":true,"productFeaturePanelOpenCloseProp":false,"productCategoryProp":true,"productStoresProp":true,"productSortProp":true,"relatedCurrentCategory":true,"productPriceFilterProp":true,"showKeywords":false,"smCardName":"mProductCard516","skeleton":"mProductArchiveSkeleton1","dashboardProduct":false,"publishStatusFilter":false,"image":null,"alt":"mix it web","cardLink":true,"infinityLoading":false,"chooseCategoriesFromTop":false,"cardLinkTarget":"_self","productStoresDirectFilter":null,"orderFilterProp":["brand","feature","category","search","quantity","store","price"],"archiveFilterProp":false},...{}}' :style='""' class="my-4 product-archive-3" ></m-products-3>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mDiv from '@moeinmdn/miw-alpha-components/src/package/Tags/Div'; import mH2 from '@moeinmdn/miw-alpha-components/src/package/Tags/H2'; import mH4 from '@moeinmdn/miw-alpha-components/src/package/Tags/H4'; import mA from '@moeinmdn/miw-alpha-components/src/package/Tags/A'; import mIcon from '@moeinmdn/miw-alpha-components/src/package/Icons/Icon'; import mProducts3 from '@moeinmdn/miw-alpha-components/src/package/Product/Products/Products3/Products3';

export default {
    name: 'HomeView',
    components: {mEdit1, mDiv,mH2,mH4,mA,mIcon,mProducts3 },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
